import { Theme } from "@/hooks/interface";

export const menuTheme: Record<Theme.ThemeType, { [key: string]: string }> = {
  light: {
    "--el-menu-bg-color": "#E9ECEF",
    "--el-header-main-bg-color": "#d6e7ff",
    "--el-table-color": "#dee2e6",
    "--el-table-event": "#e9ecef",
    "--el-menu-hover-bg-color": "#cccccc",
    "--el-menu-active-bg-color": "var(--el-color-primary-light-9)",
    "--el-menu-text-color": "#333333",
    "--el-steeper-bg-color": "#F9FAFB",
    "--el-steeper-color": "#333333",
    "--el-menu-active-color": "#006EFF",
    "--el-menu-hover-text-color": "#333333",
    "--el-menu-horizontal-sub-item-height": "50px",
    "--el-menu-left-icon-bg": "#fff",
    "--el-all-group-active": "#ced4da",
    "--el-all-group-active-color": "#006eff",
    "--el-search-text-color": "#333",
    "--el-dashboard-bg-color": "#ffffff",
    "--el-management-breadcrumb-bg-color": "#f9fafb",
    "--el-top-overview-color": "#6C757D",
    "--el-device-color": "#495057",
    "--el-device-text-color": "#212529",
    "--el-device-text-h1": "#121212",
    "--el-device-text-h2": "#6c757d",
    /* 左侧资源树行状态：两档。
       path = 祖先节点（当前路径经过它），current = 当前选中节点。 */
    "--el-tree-row-hover-bg": "rgba(0, 110, 255, 0.08)",
    "--el-tree-row-path-bg": "rgba(0, 110, 255, 0.12)",
    "--el-tree-row-path-color": "#121212",
    "--el-tree-row-current-bg": "#006eff",
    "--el-tree-row-current-color": "#ffffff"
  },
  inverted: {
    "--el-menu-bg-color": "#191a20",
    "--el-table-color": "#191a20",
    "--el-menu-hover-bg-color": "#000000",
    "--el-menu-active-bg-color": "#000000",
    "--el-menu-text-color": "#bdbdc0",
    "--el-table-event": "#e9ecef",
    "--el-header-main-bg-color": "#d6e7ff",

    "--el-menu-active-color": "#ffffff",
    "--el-menu-hover-text-color": "#ffffff",
    "--el-menu-horizontal-sub-item-height": "50px",
    "--el-menu-left-icon-bg": "#121212",
    "--el-management-breadcrumb-bg-color": "rgb(18,18,18)",
    "--el-all-group-active": "#495057",
    "--el-all-group-active-color": "#CED4DA",
    "--el-top-overview-color": "#6C757D",
    "--el-device-color": "#495057",
    "--el-device-text-color": "#212529",
    "--el-device-text-h1": "#121212",
    "--el-device-text-h2": "#6c757d"
  },
  dark: {
    "--el-header-main-bg-color": "#000000",

    "--el-menu-bg-color": "rgb(18,18,18)",
    "--el-table-color": "rgb(18,18,18)",
    "--el-menu-hover-bg-color": "#000000",
    "--el-steeper-color": "#ffffff",
    "--el-top-overview-color": "#ffffff",
    "--el-device-color": "#ffffff",
    "--el-menu-active-bg-color": "#000000",
    "--el-menu-text-color": "#ffffff",
    "--el-table-event": "rgb(18,18,18)",
    "--el-menu-active-color": "#ffffff",
    "--el-menu-hover-text-color": "#ffffff",
    "--el-menu-horizontal-sub-item-height": "50px",
    "--el-menu-left-icon-bg": "#121212",
    "--el-all-group-active": "#495057",
    "--el-all-group-active-color": "#CED4DA",
    "--el-search-text-color": "#eee",
    "--el-dashboard-bg-color": "#000000",
    "--el-steeper-bg-color": "#000000",
    "--el-management-breadcrumb-bg-color": "#000000",
    "--el-device-text-color": "#ffffff",
    "--el-device-text-h1": "#ffffff",
    "--el-device-text-h2": "#ffffff",
    /* 暗色下品牌蓝混近黑几乎不改变亮度，薄底档换成更亮的蓝并提高比例，靠亮度拉开。 */
    "--el-tree-row-hover-bg": "rgba(61, 139, 253, 0.16)",
    "--el-tree-row-path-bg": "rgba(61, 139, 253, 0.24)",
    "--el-tree-row-path-color": "#ffffff",
    "--el-tree-row-current-bg": "#006eff",
    "--el-tree-row-current-color": "#ffffff"
  }
};
